module.exports = __webpack_public_path__ + "static/media/RecomendaOuroPreto.3460a242.jpg";